import classNames from 'classnames'
import React from 'react'
import {useColors} from '../../../../hooks/colors'
import {ModalType, useModal} from '../../../../hooks/modal'
import {UpdatedIndicationProps} from './interfaces'
import s from './updated-indication.scss'

export const UpdatedIndication = ({formattedUpdatedDate, t}: UpdatedIndicationProps) => {
  const {insideModal, modalType} = useModal()
  const insideItemModal = modalType === ModalType.SCHEDULE_ITEM

  const {isDarkLinkColor} = useColors()
  const wired = isDarkLinkColor()

  return (
    <div
      className={classNames(s.container, {
        [s.insideModal]: insideModal,
        [s.wired]: wired,
        [s.insideItemModal]: insideItemModal,
      })}
    >
      <div className={s.pimple} />
      <div className={s.updatedIndicationText}>
        {t('updated')} {formattedUpdatedDate}
      </div>
    </div>
  )
}
